<template>
    <div class="clearfix">
        <div class="row stats">
            <div class="col-12">
                <div class="row">
                    <div class="col-sm-12 col-md-4">
                        <div class="box">
                            <div class="icon">
                                <Icon icon-class="ui-receipt" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    <strong>{{ stats.all_total }}</strong> {{ t('quotations-sent') }}
                                </div>

                                <div>
                                    <span class="number">
                                        {{ currencySymbol }} {{ formatNumber(stats.all_revenue) }}
                                    </span>
                                    <span>
                                        ({{ formatNumber(stats.all_percentage) }}%)
                                    </span>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4">
                        <div class="box">
                            <div class="icon">
                                <Icon icon-class="ui-users-01" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    {{ t('quotations-clients') }}
                                </div>

                                <div>
                                    <span class="number">
                                        {{ stats.total_client }}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4">
                        <div class="box">
                            <div class="icon">
                                <Icon icon-class="ui-tag-01" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    {{ t('quotations-average_ticket') }}
                                </div>

                                <div>
                                    <span class="number">
                                        {{ currencySymbol }} {{ formatNumber(stats.all_revenue / stats.total_client) }}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4">
                        <div class="box">
                            <div class="icon">
                                <Icon icon-class="ui-hourglass-03" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    <strong>{{ stats.sent_count }}</strong> {{ t('quotations-awaiting_approval') }}
                                </div>

                                <div>
                                    <span class="number">
                                        {{ currencySymbol }} {{ formatNumber(stats.sent_value) }}
                                    </span>
                                    <span>
                                        ({{ formatNumber(stats.sent_percentage) }}%)
                                    </span>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4">
                        <div class="box">
                            <div class="icon">
                                <Icon icon-class="ui-check-circle" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    <strong>{{ stats.accepted_count }}</strong> {{ t('quotations-approved') }}
                                </div>

                                <div>
                                    <span class="number">
                                        {{ currencySymbol }} {{ formatNumber(stats.accepted_value) }}
                                    </span>
                                    <span>
                                        ({{ formatNumber(stats.accepted_percentage) }}%)
                                    </span>

                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4">
                        <div class="box">
                            <div class="icon">
                                <Icon icon-class="ui-x-circle" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    <strong>{{ stats.rejected_count }}</strong> {{ t('quotations-rejected') }}
                                </div>

                                <div>
                                    <span class="number">
                                        {{ currencySymbol }} {{ formatNumber(stats.rejected_value) }}
                                    </span>
                                    <span>
                                        ({{ formatNumber(stats.rejected_percentage) }}%)
                                    </span>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../components/icon/icon";

export default {
    components: { Icon },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        formatNumber(number) {
            if (isNaN(number)) {
                return (0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            return parseFloat(number).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    },
    props: {
        stats: {
            type: Object,
            required: true
        }
    }
};
</script>
